import Client from 'shopify-buy';
import logger from '../utils/logger';

// Debug environment variables
const domain = process.env.REACT_APP_SHOPIFY_DOMAIN || '';
const token = process.env.REACT_APP_SHOPIFY_STOREFRONT_ACCESS_TOKEN || '';

// Initialize Shopify client
export const shopifyClient = Client.buildClient({
  domain: domain,
  storefrontAccessToken: token,
});

// Type definitions for better TypeScript support
export interface ShopifyProduct {
  id: string;
  title: string;
  handle: string;
  description: string;
  descriptionHtml: string;
  availableForSale: boolean;
  images: Array<{
    id: string;
    src: string;
    altText: string | null;
  }>;
  variants: Array<{
    id: string;
    title: string;
    price: {
      amount: string;
      currencyCode: string;
    };
    available: boolean;
    selectedOptions: Array<{
      name: string;
      value: string;
    }>;
  }>;
  options: Array<{
    id: string;
    name: string;
    values: string[];
  }>;
  productType: string;
  tags: string[];
  vendor: string;
  createdAt: string;
  updatedAt: string;
}

export interface ShopifyCollection {
  id: string;
  title: string;
  handle: string;
  description: string;
  descriptionHtml: string;
  image: {
    id: string;
    src: string;
    altText: string | null;
  } | null;
  products: ShopifyProduct[];
}

export interface ShopifyCheckout {
  id: string;
  webUrl: string;
  totalPrice: {
    amount: string;
    currencyCode: string;
  };
  subtotalPrice: {
    amount: string;
    currencyCode: string;
  };
  totalTax: {
    amount: string;
    currencyCode: string;
  };
  lineItems: Array<{
    id: string;
    title: string;
    quantity: number;
    variant: {
      id: string;
      title: string;
      price: {
        amount: string;
        currencyCode: string;
      };
      image: {
        src: string;
        altText: string | null;
      };
    };
  }>;
}

// Helper functions
export const formatPrice = (amount: string, currencyCode: string = 'USD'): string => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode,
  });
  return formatter.format(parseFloat(amount));
};

export const getProductImageUrl = (product: ShopifyProduct, index: number = 0): string => {
  if (product.images && product.images.length > index) {
    return product.images[index].src;
  }
  return '/placeholder-image.png';
};

export const getVariantByOptions = (
  product: ShopifyProduct,
  selectedOptions: Record<string, string>
): any => {
  return product.variants.find((variant) =>
    variant.selectedOptions.every(
      (option) => selectedOptions[option.name] === option.value
    )
  );
};